// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".aside[data-v-1f723cfe] {\n  width: 350px;\n  border-right: 1px solid #dcdfe6;\n  padding-right: 20px;\n}\n.main[data-v-1f723cfe] {\n  width: calc(100% - 370px);\n  margin-left: 20px;\n}\n.checkText p[data-v-1f723cfe],\n.checkText span[data-v-1f723cfe] {\n  margin: 0;\n  font-weight: bold;\n  font-size: 48px;\n}\n.success[data-v-1f723cfe] {\n  color: #30b08f;\n}", ""]);
// Exports
module.exports = exports;
